module.exports = __webpack_public_path__ + "static/media/LP-Mob_PaollaIvete.cd653ece.png";